// 接口前置的工具类。https://poizon.feishu.cn/docx/TUxRdPxcpoSbEcxNJqAcgaePnQh
export default class H5PreApiMonitor {
    constructor(page) {
        this.page = page
    }

    // h5RequestPromise: rn发起请求的promise，低版本客户端或者客户端因为未拿到配置信息导致没有未发起前置接口时，仍然使用原始rn方法发起请求
    // url: 请求的api全路径，不用携带参数
    // appVersion: 可选，如果有值，则进行版本判断
    async getPreData(h5RequestPromise, url, appVersion = '') {
        const [code, data] = await (new Promise((resolve, reject) => {
            window.Jockey.send('getPreApiData', {
                page: this.page,
                url: url
            }, (res) => {
                if (res) {
                    const { code, data } = res;
                    resolve([code, data || {}]);   
                } else {
                    resolve([-1, {}]);  
                }
            });
        }));
        if (code == 1) {
            return new Promise((resolve, reject) => {
                resolve(data);
            });
        } else {
            return h5RequestPromise();
        }
    }
}



// WEBPACK FOOTER //
// ./utils/H5PreApiMonitor.js